<template lang="pug">
  .b-node
    .b-node__content._draggable(
      :class="[{_dragging: draggingItem}, `_type-${type}`]"
      draggable
      @dragstart="dragStart"
      @dragend="dragEnd"
    )
      font-awesome-icon.-mr-2(
        icon="plus"
        fixed-width
      )
      | {{text}}
</template>

<script>
  import { mapFields } from 'vuex-map-fields';
  import { mapMutations } from 'vuex';
  import randomId from '@/utils/randomId';

  export default {
    name: 'NewNode',
    props: {
      text: String,
      type: String,
    },
    computed: {
      ...mapFields('nodes', [
        'date',
        'draggingItem',
        'dropType',
      ]),
    },
    methods: {
      dragStart(event) {
        // console.log('xxx NewNode - dragStart');
        this.date = Date.now();
        this.draggingItem = {
          isNew: true,
          type: this.type,
        };
      },
      dragEnd(event) {
        // console.log('xxx NewNode - dragEnd');
        this.date = Date.now();
        this.draggingItem = null;
      },
    },
  };
</script>
